<template>
  <span class="online-text">{{ onlineText }}</span>
</template>

<script>
import dayjs from 'dayjs';
import { mapState } from 'vuex';

export default {
  name: 'OnlineText',

  props: {
    userId: {
      type: Number,
      default: null,
    },

    isOnline: {
      type: Boolean,
      default: false,
    },

    wasOnlineAt: {
      type: [String, Number],
      default: null,
    },
  },

  computed: {
    ...mapState('onlineUsers', ['state']),

    onlineText() {
      if (+process.env.CURRENCY_MARKETPLACE_SKY_PRO_ID && this.userId
        && this.userId === +process.env.CURRENCY_MARKETPLACE_SKY_PRO_ID
      ) {
        return 'Online now';
      }

      const currentState = (this.userId && this.state?.[this.userId]) || {
        is_online: this.isOnline,
        was_online_at: this.wasOnlineAt,
      };

      if (currentState.is_online) {
        return 'Online now';
      }

      if (!currentState.was_online_at) {
        return 'Was online over a week ago';
      }

      let wasOnlineDate;

      if (Number.isFinite(currentState.was_online_at)) {
        wasOnlineDate = dayjs.unix(currentState.was_online_at).utc();
      } else {
        wasOnlineDate = dayjs(currentState.was_online_at).utc().add(dayjs().utcOffset(), 'minutes');
      }

      const now = dayjs().utc();

      const diff = {
        value: 0,
        unit: null,
      };
      const diffUnits = ['days', 'hours', 'minutes'];

      for (let i = 0; i < diffUnits.length; i++) {
        diff.value = now.diff(wasOnlineDate, diffUnits[i]);

        if (diff.value > 0) {
          diff.unit = diffUnits[i];
          break;
        }
      }

      if (diff.value === 1) {
        diff.unit = diff.unit.slice(0, -1);
      }

      if (diff.value === 0) {
        return 'Was online a moment ago';
      }

      return `Was online ${diff.value} ${diff.unit} ago`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
